import { Component, OnInit } from '@angular/core';
import { InternetProduct } from '@dch/products-business-logic';
import {
  ApplicationState,
  getSelectedProductAvailableOptionsError,
  getSelectedProductAvailableOptionsLoaded,
  getSelectedProductDetails,
} from '../../../../store/reducers';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { Store } from '@ngrx/store';
import { WebshopUtils } from '../../../../shared/webshop/webshop-utils';

@Component({
  selector: 'mprd-internet-available-options-container',
  templateUrl: './internet-available-options-container.component.html',
})
export class InternetAvailableOptionsContainerComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  availableOptionsLoaded: boolean;
  hasError: boolean;
  selectedProduct: InternetProduct;
  bizzGuestWifi: string;

  constructor(private store: Store<ApplicationState>) {
    super();
  }

  ngOnInit(): void {
    this.addSubscription(
      this.store
        .select(getSelectedProductAvailableOptionsError)
        .subscribe((technicalError) => {
          this.hasError = technicalError !== null;
        }),
    );
    this.addSubscription(
      this.store
        .select(getSelectedProductAvailableOptionsLoaded)
        .subscribe((availableOptionsLoaded) => {
          this.availableOptionsLoaded = availableOptionsLoaded;
        }),
    );
    this.addSubscription(
      this.store
        .select(getSelectedProductDetails)
        .subscribe((selectedProduct) => {
          if (
            selectedProduct &&
            JSON.stringify(this.selectedProduct) !==
              JSON.stringify(selectedProduct.internetProductDetails)
          ) {
            this.selectedProduct = selectedProduct.internetProductDetails;
            WebshopUtils.publishCartRetrival(
              this.selectedProduct.installationId,
              this.selectedProduct.accessNumber,
              this.selectedProduct.plc,
            );
          }
        }),
    );
  }
}
